import classNames from 'classnames';
import React from 'react'
import { FormattedMessage } from 'react-intl';

const ChangeLanguage = ({
  language,
  handlerChangeLanguage
}) => {
  return ["es", "en"].map((lang, idx) => (
    <>
      <span
        key={idx}
        className={classNames({
          "font-weight-bold available-language": true,
          "active-language": language === lang,
        })}
        onClick={() => handlerChangeLanguage(lang)}
      >
        <FormattedMessage
          id={`ProjectStepForm.step0.${lang}`}
          defaultMessage={lang === "es" ? "ES" : "EN"}
        />
      </span>
      {lang !== "en" && (
        <span className="step-info__languages-separator ml-2 mr-2">|</span>
      )}
    </>
  ));
}

export default ChangeLanguage
